import { render, staticRenderFns } from "./contactPersonTable.vue?vue&type=template&id=f11a6d20"
import script from "./contactPersonTable.vue?vue&type=script&lang=js"
export * from "./contactPersonTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports